import $ from 'jquery'

class MultiMenu {

    constructor() {
        this.menu = document.querySelector(".main-navigation-menu")
        // this.submenu = document.querySelector("li[data-toggle='dropdown'] > ul")
        this.openMenuBtn = document.querySelector(".main-navigation-toggle")
        // this.subopenButton = document.querySelector(".submenu-dropdown-toggle")
        this.events()
    }
    
    events() {
        // this.menu.style.display = 'none';
        // this.submenu.style.display = 'none';
        // this.submenu.style.visibility = 'visible';
        this.openMenuBtn.addEventListener("click", () => this.openMenu())
        // this.subopenButton.addEventListener("click", () => this.openSubMenu())

    }
    
    openMenu() {
        this.menu.classList.toggle("active")
    }  

    openSubMenu() {
        if(this.submenu.classList.toggle("submenu-navigation__menu--active")){
            this.submenu.style.display = 'block';
        }else {
            this.submenu.style.display = 'none';
        }
        
    }  

}
export default MultiMenu 